export enum ProductLine {

    CONNECTO = 0,

    ALBA = 1,

    ASTRO = 2,
}
